




























































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import BackofficeGlobalStore from '@/components/Backoffice/Store/BackofficeGlobalStore'
import { getUfs, opcaoHabilitadoShared, campoHabilitadoShared } from '@/utils/common'

@Component
export default class BackofficeEquipeMEdica extends Vue {
  $refs!: { equipeMedica: any }

  equipeMedicaRules: any = {
    valid: true,
    equipeMedica: [],
    equipeMedicaEspecificar: [(v: any) => !!v || 'Campo obrigatório.'],
  }

  hasSurgeryTeam: 1 | 0 | '1' | '0'
  ufs: any[] = [...getUfs()]

  get getBackofficeGlobalStore() {
    return getModule(BackofficeGlobalStore, this.$store)
  }

  campoHabilitado(prop: string) {
    return campoHabilitadoShared(this.getBackofficeGlobalStore.template, prop)
  }

  opcaoHabilitado(prop1: string, prop2: string) {
    return opcaoHabilitadoShared(this.getBackofficeGlobalStore.template, prop1, prop2)
  }

  campoObrigatorio(campo: string) {
    const formulario = this.getBackofficeGlobalStore.currentTemplate
    if (formulario.formulario
      && formulario.formulario[campo]
      && (formulario.formulario[campo].obrigatorio
        || formulario.formulario[campo].obrigatorioParaTodosOsConvenios
        || formulario.formulario[campo].obrigatorioParaConvenioParticular)
    ) {
      return true
    }
    return false
  }

  get doctorsSurgeryTeam() { return this.getBackofficeGlobalStore.solicitacaoAlterada.equipeCirurgica }

  set doctorsSurgeryTeam(doctorData) { this.getBackofficeGlobalStore.solicitacaoAlterada.equipeCirurgica = doctorData }

  addDoctorToSurgeryTeam() { this.doctorsSurgeryTeam!.push({ conselhoTipo: '', conselhoUf: '', conselhoNumero: '', medicoNome: '' }) }

  deleteDoctorFromSurgeryTeam(index) { this.doctorsSurgeryTeam!.splice(index, 1) }

  get surgeryTeamTypes() {
    return [
      { description: 'CRM', value: 'CRM' },
      { description: 'CRO', value: 'CRO' },
    ]
  }

  get surgeryTeamDoctorDataFieldRule() {
    const rule: any = []

    if (this.campoObrigatorio('equipeMedica')) {
      rule.push((v: any) => !!v || 'Campo obrigatório.')
    }

    return rule
  }

  equipeMedicaChange(equipeMedica) {
    this.equipeMedicaRules.equipeMedica.splice(0, this.equipeMedicaRules.equipeMedica.length)

    if (equipeMedica === 1 || equipeMedica === '1') {
      this.getBackofficeGlobalStore.setSolicitacaoAlteradaFields({ field: 'temEquipeMedica', value: true })

      this.equipeMedicaRules.equipeMedicaEspecificar.push((v: any) => !!v || 'Campo obrigatório.')

      if (this.doctorsSurgeryTeam!.length === 0) {
        this.doctorsSurgeryTeam!.push({ conselhoTipo: '', conselhoUf: '', conselhoNumero: '', medicoNome: '' })
      }
    } else {
      this.getBackofficeGlobalStore.setSolicitacaoAlteradaFields({ field: 'temEquipeMedica', value: false })

      this.equipeMedicaRules.equipeMedicaEspecificar.splice(0, this.equipeMedicaRules.equipeMedicaEspecificar.length)
      this.getBackofficeGlobalStore.setSolicitacaoAlteradaFields({ field: 'equipeMedicaEspecificar', value: '' })

      this.doctorsSurgeryTeam = []
    }
  }

  @Watch('getBackofficeGlobalStore.solicitacaoAlterada.temEquipeMedica')
  onSurgeryTeamChange(value: boolean | null) {
    if (typeof this.getBackofficeGlobalStore.solicitacaoAlterada.temEquipeMedica === 'boolean') {
      if (this.getBackofficeGlobalStore.solicitacaoAlterada.temEquipeMedica) {
        this.hasSurgeryTeam = '1'
      } else {
        this.hasSurgeryTeam = '0'
      }
    }
  }
}
